import { Component, OnInit } from '@angular/core';
import { GuiService } from 'src/app/services/gui.service';

@Component({
  selector: 'vex-register-confirm-mobile',
  templateUrl: './register-confirm-mobile.component.html',
  styleUrls: ['./register-confirm-mobile.component.scss']
})
export class RegisterConfirmMobileComponent implements OnInit {


  constructor(public guiService: GuiService) {

  }

  ngOnInit(): void {
    setTimeout(() => this.guiService.showSpinner = false, 2000)
  }

}
